// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  cloudfrontUrl: "https://d1rbwpjivx5ceh.cloudfront.net/",
  VimeoUrlRegExp: /^https:\/\/vimeo.com\/video\/(.+)/,
  signUpDefaultInstitutionId: "e9968918-5d7d-4390-8d6d-3dbd474241a7",
  signUpDefaultAvatarSDKAvatarCode: "Oculus",
  fileUploadSizeLimit_MB: 500,
  rpmAvatarUrlRegExp: /^https:\/\/models.readyplayer.me\/\w{24}.glb$/
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
